import { render, staticRenderFns } from "./AllowancesPlanFloatBtns.vue?vue&type=template&id=5840752c&"
import script from "./AllowancesPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports